document.addEventListener("DOMContentLoaded", function () {
  setTimeout(()=>{
    pfSubscription();
  }, 1000);
  pfSubscription();
});

document.addEventListener("shopify:section:load", function () {
  setTimeout(()=>{
    pfSubscription();
  }, 1000);
  pfSubscription();
});

window.addEventListener("load", function () {
  const appBoilerPlate = document.querySelector(".shopify-app-block.pf-app-boiler-plate .sealsubs-target-element");
  const appOriginalPlate = document.querySelector(".shopify-app-block:not(.pf-app-boiler-plate) .sealsubs-target-element");

  appOriginalPlate.style.display = "block";
  appBoilerPlate.style.display = "none";

  pfSubscription();
});

function pfSubscription(){
  //=========== selector ============//
  const subsPickers = document.querySelectorAll(".pf-custom-product .sealsubs-target-element .sls-purchase-options-container .sls-option-container");
  
  const oneTimeSaveDatas = document.querySelectorAll(".pf-custom-product .pf-text-box .pf-sub-text .pf-one-time-save");
  const subscriptionSaveDatas = document.querySelectorAll(".pf-custom-product .pf-text-box .pf-sub-text .pf-subscription-save");
  
  const oneTimePrices = document.querySelectorAll(".pf-custom-product .pf-right-box .pf-main-price.pf-one-time-price");
  const subscriptionPrices = document.querySelectorAll(".pf-custom-product .pf-right-box .pf-main-price.pf-subscription-price");

  const defalutVariant = document.querySelector(".pf-custom-product .variant-input-wrap .variant-input:nth-child(3) .variant__button-label");
  // const defalutPlan = document.querySelector(".pf-custom-product .sealsubs-target-element .sls-option-container:nth-last-of-type(1)");
  const appBoilerPlate = document.querySelector(".shopify-app-block.pf-app-boiler-plate .sealsubs-target-element");
  const appOriginalPlate = document.querySelector(".shopify-app-block:not(.pf-app-boiler-plate) .sealsubs-target-element");


  // atc button
  const mainAtcButton = document.querySelector(".pf-custom-product .product-single__form .add-to-cart");

  mainAtcButton?.addEventListener("click", ()=>{
    setTimeout(()=>{
      window.location.replace("/checkout");
    }, 500);
  })


  



  //============= events =============//

  
  // subscription change event

  subsPickers.forEach((picker)=>{
    picker.addEventListener("click", ()=>{
      const type = picker.querySelector("input.sls-option").getAttribute("data-type");

      updateData(type);
      console.log(type);
    });
  });


  function updateData(type){
    if(type == "subscription"){
      // save percentage
      oneTimeSaveDatas.forEach(elm=>elm.classList.remove("active"));
      subscriptionSaveDatas.forEach(elm=>elm.classList.add("active"));

      // price
      oneTimePrices.forEach(elm=>elm.classList.remove("active"));
      subscriptionPrices.forEach(elm=>elm.classList.add("active"));
    } else {
      // save percentage
      subscriptionSaveDatas.forEach(elm=>elm.classList.remove("active"));
      oneTimeSaveDatas.forEach(elm=>elm.classList.add("active"));

      // price
      subscriptionPrices.forEach(elm=>elm.classList.remove("active"));
      oneTimePrices.forEach(elm=>elm.classList.add("active"));
    }
  }


  




  // load

  defalutVariant.click();
  
  console.log("loaded", defalutVariant);
}